/**
 * Thrown when no valid consent configuration was found.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class ConfigurationMissingError extends Error {

}

/**
 * Thrown when no valid consent options were found.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class OptionsMissingError extends Error {

}

/**
 * Thrown when the view container was not found on the website.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class ViewContainerMissingError extends Error {

}

/**
 * Thrown when a view was unknown and therefore not supported.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class UnknownViewError extends Error {

}

/**
 * Thrown when a checkbox is missing for a consent option.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class CheckboxForOptionMissingError extends Error {

}

/**
 * Thrown when an option was not found for an option identifier.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class OptionForIdentifierMissingError extends Error {

}
